import AccountRepository from '@/shared/http/repositories/access/account.js'
import GroupRepository from '@/shared/http/repositories/configurations/group.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'

import Loading from '@/components/UI/Loading'
import { toast } from '@/shared/utils/UIHelper'

import ActionsForm from '@/shared/mixins/actionsForm'
import addAsignForm from './addAsign-form.js'

export default {
  name: 'AddAsignModal',
  mixins: [ActionsForm],
  props: {
    modalType: {
      type: String,
      default: null
    },
    selectedCards: {
      required: true
    },

    filters: {
      default: null
    },
    eventManager: {
      type: Object
    }
    // allSelected
  },
  components: {
    Loading
  },
  data () {
    return {
      warnMessage: '',
      title: '',
      selected: null,
      asignType: null,
      form: addAsignForm,
      submited: false,
      isLoading: false
    }
  },
  methods: {
    showModal () {
      this.modalType === 'add' ? this.setModalAdd() : this.setModalRemove()
      this.$refs['modal-addAsign'].show()
    },
    hideModal () {
      if (!this.submited) this.abort()

      this.$emit('closeModal')
      this.$destroy()
    },
    abort () {
      this.$emit('Abort')
    },
    setModalAdd () {
      this.title = 'ATRIBUIR RESPONSABILIDADES'
      this.warnMessage =
        'Caso algum contrato já esteja atribuido, as responsabilidades anteriores serão removidas!'
    },
    setModalRemove () {
      this.title = 'REMOVER RESPONSABILIDADES'
      this.warnMessage = 'As responsabilidades anteriores serão removidas!'
    },
    manageRadioButton () {
      if (this.selected === 'person') {
        this.onLoadAllAccount()
      } else if (this.selected === 'group') {
        this.onLoadAllGroups()
      }
    },
    onLoadAllAccount () {
      AccountRepository.GetAllName()
        .then(response => {
          this.form.responsiblePerson.options = response.data.content.map(
            usuario => {
              return { text: usuario.nomePessoa, value: usuario.id }
            }
          )
        })
        .catch(err => {
          console.error(err)
        })
    },
    onLoadAllGroups () {
      GroupRepository.GetAllActive()
        .then(response => {
          this.form.responsibleGroup.options = response.data.content.map(
            group => ({ text: group.nameGroup, value: group.id })
          )
        })
        .catch(err => {
          console.error(err)
        })
    },
    onSave () {
      if (this.eventManager) {
        this.storeSubmit()
      } else {
        if (this.modalType === 'add') this.setResponsibles()
        else if (this.modalType === 'remove') this.removeResponsibles()
      }
    },
    storeSubmit () {
      if (
        !this.form.responsiblePerson.value &&
        !this.form.responsibleGroup.value
      ) {
        return
      }

      let submit = () => this.setResponsibles()
      this.submited = true
      this.$emit('Submit', submit)
      this.$emit('closeModal')
    },
    async setResponsibles () {
      let isGroup = this.selected === 'group'

      let payload = {
        cardIds: this.selectedCards || null,
        responsavelId: !isGroup ? this.form.responsiblePerson.value : null,
        grupoResponsavelId: isGroup ? this.form.responsibleGroup.value : null,
        grupo: isGroup,
        filters: this.selectedCards ? null : this.filters
        // filters: this.selectedCards ? null : this.mapQueryStringToObject(this.filters)
      }

      if (
        !this.form.responsiblePerson.value &&
        !this.form.responsibleGroup.value
      ) {
        return
      }

      setTimeout(() => {
        this.isLoading = true
        this.$refs['modal-addAsign'].hide()
      }, 300)

      await CardRepository.SetLeadOwner(payload, this.filters)
        .then(response => {
          this.isLoading = false
          if (response.status === 204) {
            if (!this.eventManager) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
            this.$nextTick(() => {
              this.submited = true
              // this.hideModal()
            })
          }
        })
        .catch(this.onException)
    },
    removeResponsibles () {
      let isGroup = this.selected === 'group'

      let payload = {
        cardIds: this.selectedCards || null,
        responsavelId: null,
        grupoResponsavelId: null,
        grupo: isGroup,
        filters: this.selectedCards ? null : this.filters
        // filters: this.selectedCards ? null : this.mapQueryStringToObject(this.filters)
      }

      CardRepository.SetLeadOwner(payload)
        .then(response => {
          if (response.status === 204) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$nextTick(() => {
              this.hideModal()
            })
            // TODO: PRECISA ATUALIZAR O FOLLOW-UP
          }
        })
        .catch(this.onException)
    },
    mapQueryStringToObject (queryString) {
      if (!queryString) return null

      const params = new URLSearchParams(queryString)
      const result = {}

      for (const [key, value] of params.entries()) {
        result[key] = value
      }

      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/cobranca/modal/asign/addAsign.js